<template>
  <div class="main-width">
    <div class="location_css">
      <img src="@/assets/img/location.png" />
      <div>当前位置：</div>
      <div @click="goSy()">首页</div>
      <div><i class="el-icon-arrow-right"></i></div>
      <div>{{ $route.query.cid?this.categoryList[0].name : title }}</div>
      <div><i class="el-icon-arrow-right"></i></div>
      <div class="location_text">{{ currentCategoryData.name || currentCategoryData.title }}</div>
    </div>
    <div class="culture_main">
      <div class="culture_left">
        <div class="culture_left_title">{{ $route.query.cid?this.categoryList[0].name : title }}</div>

        <div style="background:#eef2f7;max-height:calc(100% - 45px);" v-for="(item, index) in categoryList" :key="index" @click="categoryClick(item,index)">
          <div class="category-item" :class="{'category-item-active':item.isActive}" v-if="!$route.query.cid">
            <i v-if="item.children" :class="{'el-icon-plus':!item.isActive,'el-icon-minus':item.isActive}"/>
            <div style="padding-left:10px;">{{ item.name }}</div>
            <i style="transition: transform .3s;" class="el-icon-arrow-right" :class="{'el-icon-arrow-right-isActive':item.children && item.isActive}"/>
          </div>

          <el-collapse-transition>
          <div v-show="(item.children && item.isActive) || $route.query.cid">
          <div  v-for="(p, i) in item.children" :key="i" @click.stop="childrenClick(p)">
            <div class="category-children-item" :class="{'isActive':p.channelId == currentCategoryData.channelId}">{{p.title}}</div>
          </div>
          </div>
          </el-collapse-transition>
          
        </div>

      </div>
      <div class="culture_right" v-loading="loading">
        <div v-if="!newsList || newsList.length == 0" style="text-align: center;padding-top: 120px;">
          <img src="@/assets/img/nodata.png" style="width:100px"/>
          <div style="font-size:14px;color:#bfbfbf;margin-top:8px">暂无数据</div>
        </div>
        <div v-for="(item, index) in newsList" :style="{'border-bottom':index == (newsList.length - 1) ? 'none' : '1px solid #949494'}" :key="index" style="cursor:pointer;" @click="goDetail(item.contentid)">
          <div style="color:#4169ae;font-size:14px;padding-top:15px">{{item.title}}</div>
          <div style="color:#949494;padding-top:15px;padding-bottom:15px">更新日期：{{item.postDate.split(" ")[0]}} 来源：{{item.originUrl}}</div>
        </div>
        <!-- <div
          class="news_item"
          v-for="(item, index) in newsList"
          :key="index"
          @click="goDetail(item.contentid)"
        >
          <div>
            <img
              style="width:7px;height:7px;margin-right:5px"
              src="@/assets/img/point.png"
            />
          </div>
          <div class="news_item_text">{{ item.title }}</div>
          <div class="news_item_date">{{ item.postDate }}</div>
        </div> -->
        <div
          v-if="newsList.length > 0 && total > params.pageSize"
          class="pagination"
          style="text-align: center;margin-top: 50px;padding-bottom:20px"
        >
          <el-pagination
            background
            layout="total, prev, pager, next"
            :current-page="params.pageNum"
            :page-size="params.pageSize"
            :total="total"
            @current-change="pageChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    categoryList: {
      type: Array,
      default: [],
    },
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      newsList: [],
      currentCategoryData: {},
      total: 0,
      params: {
        pageNum: 1,
        pageSize: 8,
      },
    };
  },
  //   computed:{
  //       categoryList(){
  //           return [{channelId:161,title:"时政要闻"},{channelId:173,title:"产业要闻"},{channelId:168,title:"通知公告"}];
  //       }
  //   },
  watch: {
    currentCategoryData: {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal && newVal.channelId) {
          this.params.pageNum = 1;
          this.getNewsByChannelId();
        }
      },
    },
  },
  methods: {
    categoryClick(data,index){
      this.categoryList.forEach((item,i) =>{
        if(index != i){
          item.isActive = false;
        };
      });
      if(data.children){
        this.$set(data,"isActive",!data.isActive);
      }else{
        data.isActive = true;
        this.currentCategoryData = JSON.parse(JSON.stringify(data))
      };
      // if(data.children){
      //   data.isActive = !data.isActive;
      // }else{
      //   this.currentCategoryData = JSON.parse(JSON.stringify(data));
      // };
    },
    childrenClick(data){
      this.currentCategoryData = JSON.parse(JSON.stringify(data));
    },
    goDetail(contentid) {
      this.$router.push({
        path: "/news/detail",
        query: {
          contentId: contentid,
        },
      });
    },
    //翻页
    pageChange(page) {
      this.params["pageNum"] = page;
      this.getNewsByChannelId();
    },
    //返回首页
    goSy: function() {
      this.$router.push({
        path: "/home",
      });
    },
    //获取新闻列表
    getNewsByChannelId() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        this.$axios
          .get("rrb-web/news/content/ext/list", {
            params: {
              ...this.params,
              channelId: this.currentCategoryData.channelId,
            },
          })
          .then(
            (resp) => {
              if (resp.errcode == 0 || resp.errcode == "0") {
                resp.data.dataList = resp.data.dataList.map((item) => ({
                  ...item,
                  postDate: item.postDate ? item.postDate.split(" ")[0] : "",
                }));
                this.newsList = resp.data.dataList;
                this.total = resp.data.totalRow;
              }
              resolve();
              this.loading = false;
            },
            () => {
              resolve();
              this.loading = false;
            }
          );
      });
    },
  },
  mounted() {
    if(this.$route.query.cid){
      this.categoryList = this.categoryList.filter(item => item.channelId == this.$route.query.cid);
    };
    this.$set(this, "currentCategoryData", this.categoryList[0].children ? this.categoryList[0].children[0] : this.categoryList[0]);
  },
};
</script>
<style scoped lang="scss">
::v-deep{
  .el-collapse-item__header{
    padding-left:20px;
    color:white !important;
    background: #035AB1 !important;
  }
}
.category-item-active{
  color:white !important;
  background: #035AB1 !important;
}
.isActive{
  background: white !important;
  color:#2d70f6 !important;
}
.el-icon-arrow-right-isActive{
  transform: rotate(90deg);
}

</style>
